export default {"src":"/_next/static/media/topbarnotification.07c7bf66.svg","height":25,"width":20,"blurWidth":0,"blurHeight":0};